<template>
    <div class="tab-content">
        <card-spinner v-if="loading" style="height: 200px;"/>

        <div v-else role="tabcard" class="tab-pane active" id="users">
            <div class="card p-3 pb-4" v-for="user in users" :key="user.id">
                <h5 class="card-title">
                    <img :src="user.photo_url" class="profile__image ml-md-1 img-responsive">
                    {{user.name}}
                </h5>
                <div class="d-md-flex justify-content-md-between">
                    <count-metric
                        class="flex m-md-1"
                        title="Total invites"
                        :count="user.total_invites"
                    />

                    <percent-metric
                        class="m-md-1"
                        :title="user.invites_sent + ' Invites Sent'"
                        :number="user.invites_sent ? Math.round((user.invites_sent * 100)/user.total_invites) : 0"
                    />

                    <percent-metric
                        class="m-md-1"
                        :title="user.invites_opened + ' Invites opened'"
                        :number="user.invites_opened ? Math.round((user.invites_opened * 100)/user.total_invites) : 0"
                    />

                    <percent-metric
                        class="m-md-1"
                        :title="user.invites_shared + ' Clicked to review site'"
                        :number="user.invites_shared ? Math.round((user.invites_shared * 100)/user.total_invites): 0"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { mapState, mapMutations } from 'vuex';
    import mutations from '../../store/mutation-types';

    export default {
        data() {
            return {
                loading: true,
                users: []
            };
        },

        created() {
            this.fetchUsers();
        },

        computed: {
            filterIsEmpty() {
                return (
                    this.location === null &&
                    this.campaign === null &&
                    this.region === null &&
                    this.tag === null &&
                    this.dateRange === null &&
                    this.search === null &&
                    this.fixedDateRange === null
                );
            },
            ...mapState({
                filter: state => state.filter
            })
        },

        watch: {
            filter() {
                this.fetchUsers();
            }
        },

        methods: {
            ...mapMutations({
                update: mutations.UPDATE_FILTER
            }),

            fetchUsers() {
                this.loading = true;

                let params = {
                    filter: { ...this.filter }
                };

                this.$http.get('/leaderboards-show', { params }).then(response => {
                    this.users = response.data.data;
                    this.loading = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .profile__image {
        border-radius: 50%;
        width: 45px;
        margin: 7.5px 7.5px 7.5px 0;
    }
</style>
